import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { RegisteredNode, RegisteredNodeServerResponse } from 'data/registeredNode/registeredNode.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: RegisteredNodeServerResponse,
  originalDigitExtractionServerFormData: RegisteredNode | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.REGISTERED_NODES_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.REGISTERED_NODES_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.id,
    AuditService.REGISTERED_NODES,
    actionType,
  );
  return auditDetails as AuditDetails;
}
